import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import { FormattedMessage, useIntl } from "react-intl";

import headerStyles from "../../../../theme/header.module.css";
import Instructions from ".";

export default function BehaviorMobile() {
  const intl = useIntl();
  return (
    <IonPage id="main-content">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              defaultHref="/"
              text={intl.formatMessage({ id: "common.back" })}
            />
          </IonButtons>
          <IonTitle>
            <FormattedMessage id="ai.settings.instructions" />
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen color="light" className="ion-padding">
        <div className="view-wrapper">
          <div className="view-pane">
            <div>
              <div className={headerStyles.header}>
                <h1 className={headerStyles.mobileTitle}>
                  <FormattedMessage id="ai.settings.instructions" />
                </h1>
                <h3 className={headerStyles.mobileDescription}>
                  <FormattedMessage id="ai.settings.instructions.desc" />
                </h3>
              </div>
            </div>
          </div>
          <div className="view-pane">
            <div className="view-pane-body h-100">
              <Instructions />
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  )
}
